import { useEffect, useState } from "react";
import { UserCheck, UserX } from "lucide-react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const EXTERNE = "__externe__";

export function usePrescripteurs(enabled = true) {
  const [list, setList] = useState([]);
  const [tick, setTick] = useState(0);
  useEffect(() => { if (enabled) { api.get("/demandes/prescripteurs").then((r) => setList(r.data)).catch(() => {}); } }, [enabled, tick]);
  list.reload = () => setTick((n) => n + 1);
  return list;
}

/** Sélecteur : compte clinicien (accès au dossier) ou prescripteur externe sans compte (aucun accès). */
export const PrescripteurSelect = ({ list, value, onChange, testId = "prescripteur-select" }) => (
  <div>
    <Select value={value || EXTERNE} onValueChange={(v) => onChange(v === EXTERNE ? null : list.find((c) => c.id === v))}>
      <SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value={EXTERNE}>Médecin prescripteur externe (sans compte)</SelectItem>
        {list.map((c) => <SelectItem key={c.id} value={c.id}>{c.nom} · {c.email}</SelectItem>)}
      </SelectContent>
    </Select>
    <div className="mt-1 flex items-center gap-1 text-[11px] text-slate-500" data-testid={`${testId}-hint`}>
      {value ? <><UserCheck className="h-3 w-3 text-emerald-600" /> Ce médecin verra ce dossier dans son compte.</>
        : <><UserX className="h-3 w-3" /> Aucun compte relié : aucun médecin externe n'aura accès à ce dossier.</>}
    </div>
  </div>
);
